export default __webpack_public_path__ + "static/media/rezRateLogo.c12c566e.png";